var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { ModulesState } from 'src/app/modules/state/modules.state';
import { Observable, Subject, merge } from 'rxjs';
import { GetModulePrimaryCategories, GetModuleSecondaryCategories } from 'src/app/modules/state/modules.actions';
import { FormBuilder } from '@angular/forms';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { GalleryState } from '../../state/gallery.state';
import { GallerySearchMode } from '../../models/gallery-search-mode.enum';
import { GalleryActions } from '../../state/gallery.actions';
export class GalleryFiltersLoftComponent {
    constructor(store, formBuilder) {
        this.store = store;
        this.formBuilder = formBuilder;
        this.gallerySearchMode = GallerySearchMode;
        this.ngUnsubscribe = new Subject();
    }
    get primaryCategoryControl() {
        return this.queryForm.get('primaryCategory');
    }
    get secondaryCategoryControl() {
        return this.queryForm.get('secondaryCategory');
    }
    get pathControl() {
        return this.pathForm.get('path');
    }
    ngOnInit() {
        this.initForms();
        this.initFormListeners();
        this.store.dispatch(new GetModulePrimaryCategories());
        this.store.dispatch(new GetModuleSecondaryCategories(this.primaryCategoryControl.value));
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    initForms() {
        this.queryForm = this.formBuilder.group({
            'primaryCategory': ['production'],
            'secondaryCategory': ['maleAdult']
        });
        this.pathForm = this.formBuilder.group({
            'path': []
        });
        this.searchLoft(this.getQuery());
    }
    initFormListeners() {
        // Update the secondary category, since it's dependent on the primary to populate
        this.primaryCategoryControl.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((value) => {
            this.handlePrimaryUpdate(value);
        });
        // Handle all changes
        merge(this.queryForm.valueChanges, this.pathForm.valueChanges)
            .pipe(debounceTime(300), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.searchLoft(this.getQuery());
        });
    }
    toggleSearchMode(mode) {
        this.store.dispatch(new GalleryActions.SetSearchMode(mode));
    }
    handlePrimaryUpdate(value) {
        this.secondaryCategoryControl.setValue('');
        this.store.dispatch(new GetModuleSecondaryCategories(value));
    }
    searchLoft(query) {
        this.store.dispatch(new GalleryActions.SearchLoft(query.primaryCategory, query.secondaryCategory, query.name));
    }
    getQuery() {
        const result = {
            primaryCategory: '',
            secondaryCategory: '',
            name: ''
        };
        switch (this.store.selectSnapshot(GalleryState.getSearchMode)) {
            case GallerySearchMode.Query:
                result.primaryCategory = this.primaryCategoryControl.value;
                result.secondaryCategory = this.secondaryCategoryControl.value;
                break;
            case GallerySearchMode.Path:
                const query = decodeURIComponent(this.pathControl.value || '');
                const paths = query.split('/');
                // Match directories by checking for trailing /
                const regex = /([A-Za-z_-\s0-9]*\/)/gi;
                const directories = query.match(regex);
                // Don't search when no primary directory is specified
                if (directories != null) {
                    result.primaryCategory = (directories[0] || '').replace('/', '');
                    result.secondaryCategory = (directories[1] || '').replace('/', '');
                    result.name = paths.pop();
                }
        }
        return result;
    }
}
__decorate([
    Select(ModulesState.getPrimaryCategoryOptions('read')),
    __metadata("design:type", Observable)
], GalleryFiltersLoftComponent.prototype, "primaryCategoryOptions$", void 0);
__decorate([
    Select(ModulesState.getSecondaryCategoryOptions),
    __metadata("design:type", Observable)
], GalleryFiltersLoftComponent.prototype, "secondaryCategoryOptions$", void 0);
__decorate([
    Select(GalleryState.getSearchMode),
    __metadata("design:type", Observable)
], GalleryFiltersLoftComponent.prototype, "searchMode$", void 0);
